module.exports = __webpack_public_path__ + "static/media/home.403011e6.webp";